var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusInFire(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "23px",
    height: "24px",
    viewBox: "0 0 23 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(79.215686%,23.529412%,23.921569%)",
      fillOpacity: 1
    },
    d: "M 11.5 0.292969 C 17.851562 0.292969 23 5.535156 23 12 C 23 18.464844 17.851562 23.707031 11.5 23.707031 C 5.148438 23.707031 0 18.464844 0 12 C 0 5.535156 5.148438 0.292969 11.5 0.292969 Z M 11.5 0.292969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15.800781 12.203125 C 14.898438 9.816406 11.683594 9.6875 12.460938 6.214844 C 12.519531 5.957031 12.246094 5.761719 12.027344 5.894531 C 9.941406 7.148438 8.441406 9.660156 9.699219 12.949219 C 9.804688 13.21875 9.492188 13.46875 9.269531 13.292969 C 8.226562 12.492188 8.117188 11.339844 8.210938 10.511719 C 8.246094 10.207031 7.855469 10.0625 7.6875 10.3125 C 7.296875 10.921875 6.898438 11.90625 6.898438 13.386719 C 7.117188 16.664062 9.839844 17.671875 10.816406 17.800781 C 12.214844 17.980469 13.726562 17.71875 14.8125 16.707031 C 16.007812 15.578125 16.445312 13.773438 15.800781 12.203125 Z M 10.464844 15.148438 C 11.292969 14.945312 11.71875 14.335938 11.832031 13.796875 C 12.023438 12.960938 11.28125 12.140625 11.78125 10.816406 C 11.972656 11.914062 13.660156 12.597656 13.660156 13.792969 C 13.707031 15.273438 12.132812 16.542969 10.464844 15.148438 Z M 10.464844 15.148438 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusInFire);
export default __webpack_public_path__ + "static/media/status_in_fire.0af7a2226d2ad3969fb43c16c4a9c95c.svg";
export { ForwardRef as ReactComponent };